<template>
    <div class="ttl-checkbox">
    <el-checkbox v-model="inputvalue" @change="ChangeData" />
    </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
      return {
          inputvalue:false,
      }
  },

  watch: {
      value(val) {
          
          this.inputvalue=val;
      }
  },

  mounted() {
      
  },

  methods: {


      /** 修改数据，变更 **/
      ChangeData() {
          this.$emit('finish',{type:'change',value:this.inputvalue});
      },

  }

}
</script>

<style scoped>
::v-deep(.el-switch__label *) {font-size:13px;color:#666666;letter-spacing: 1px;}
</style>